export default __webpack_public_path__ + "img/black-screen.58cfb926.png";